(() => {
  'use strict';
  const form = document.querySelector('[data-personalized-form]');
  if (form) {
    const qty = form.querySelector('[name="quantity"]');
    const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    const fmt = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:(window.Trikolumo||{}).currency || 'USD', maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
    const sync = () => {
      form.querySelectorAll('[data-qty-show]').forEach(el => {el.textContent = qty.value;});
      const v = variants.find(x => x.id === Number(form.querySelector('[name="id"]:checked')?.value));
      const save = document.querySelector('[data-save-amount]');
      const priceEl = document.querySelector('[data-product-price]'); const startState = priceEl && priceEl.textContent.trim().startsWith('From'); if (!startState && v && save && v.compare_at_price > v.price) save.textContent = fmt(v.compare_at_price - v.price);
    };
    form.addEventListener('click', event => {if (event.target.closest('[data-quantity-adjust]')) setTimeout(sync, 0);});
    form.addEventListener('change', sync);
    form.querySelectorAll('[data-qty-show]').forEach(el => {el.textContent = qty.value;});
    const sticky = document.querySelector('[data-lf-sticky]');
    const cta = form.querySelector('[data-add-button]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {const e = entries[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;}).observe(cta);
      sticky.querySelector('a').addEventListener('click', event => {event.preventDefault(); form.scrollIntoView({behavior:'smooth', block:'start'}); form.querySelector('[name="properties[Name]"]')?.focus({preventScroll:true});});
    }
  }
  // Pied du panier, modèle MOLDEVA : sous-total barré (prix de référence), économie, total.
  const mapEl = document.querySelector('[data-cart-compare-map]');
  if (mapEl) {
    let map = {}; try {map = JSON.parse(mapEl.textContent);} catch (e) {}
    const eur = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:(window.Trikolumo||{}).currency || 'USD'}).format(cents / 100);
    document.addEventListener('trikolumo:cart-painted', event => {
      const cart = event.detail || {items:[]};
      const ref = (cart.items || []).reduce((sum, item) => sum + Math.max(Number(map[item.variant_id]) || 0, item.original_price) * item.quantity, 0);
      const save = ref - cart.total_price;
      const show = save > 0 && cart.item_count > 0;
      document.querySelector('[data-cart-compare-row]').hidden = !show;
      document.querySelector('[data-cart-save-row]').hidden = !show;
      if (show) {document.querySelector('[data-cart-compare]').textContent = eur(ref); document.querySelector('[data-cart-save]').textContent = '−' + eur(save);}
    });
  }
  // Minuteur du panier (5 min, modèle panier MOLDEVA) : démarre au premier article, repart à zéro quand il expire.
  const clock = document.querySelector('[data-lf-timer-clock]');
  const bar = document.querySelector('[data-lf-timer]');
  if (clock && bar) {
    const KEY = 'tl-cart-until', SPAN = 5 * 60 * 1000;
    const paint = () => {
      if (bar.hidden) return;
      let until = Number(sessionStorage.getItem(KEY)) || 0;
      if (until < Date.now()) {until = Date.now() + SPAN; sessionStorage.setItem(KEY, String(until));}
      const s = Math.max(0, Math.round((until - Date.now()) / 1000));
      clock.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    };
    const footer = document.querySelector('[data-cart-footer]');
    const show = () => {bar.hidden = !footer || footer.hidden; if (bar.hidden) sessionStorage.removeItem(KEY); else paint();};
    if (footer) new MutationObserver(show).observe(footer, {attributes:true, attributeFilter:['hidden']});
    show(); paint(); setInterval(paint, 1000);
  }
})();
